import { flushReduxPersistCache } from "web/store";

const clearCache = async () => {
  sessionStorage.clear();
  localStorage.clear();
  await flushReduxPersistCache();
};

export default clearCache;
